import { render, staticRenderFns } from "./PartnerFaqPage.vue?vue&type=template&id=070699e3&"
import script from "./PartnerFaqPage.vue?vue&type=script&lang=js&"
export * from "./PartnerFaqPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports